import exterior from '../assets/images/tour/responsive/exterior-wide.webp';
import reception from '../assets/images/tour/reception.webp';
import ed209 from '../assets/images/tour/responsive/ed209-wide.webp';
import lounge from '../assets/images/tour/lounge.webp';
import robocop from '../assets/images/tour/responsive/robocop-wide.webp';
import terrace from '../assets/images/tour/terrace.webp';
import harley from '../assets/images/tour/harley.webp';
import kitchen from '../assets/images/tour/kitchen.webp';
import shop from '../assets/images/tour/shop.webp';
import exteriorMobile from '../assets/images/tour/responsive/exterior-mobile.webp';
import receptionMobile from '../assets/images/tour/responsive/reception-mobile.webp';
import ed209Mobile from '../assets/images/tour/responsive/ed209-mobile.webp';
import robocopMobile from '../assets/images/tour/responsive/robocop-mobile.webp';
import terraceMobile from '../assets/images/tour/responsive/terrace-mobile.webp';
import harleyMobile from '../assets/images/tour/responsive/harley-mobile.webp';
import kitchenMobile from '../assets/images/tour/responsive/kitchen-mobile.webp';
import shopMobile from '../assets/images/tour/responsive/shop-mobile.webp';
import t0 from '../assets/images/tour/exterior-thumb.webp';
import t1 from '../assets/images/tour/reception-thumb.webp';
import t2 from '../assets/images/tour/ed209-thumb.webp';
import t3 from '../assets/images/tour/lounge-thumb.webp';
import t4 from '../assets/images/tour/robocop-thumb.webp';
import t5 from '../assets/images/tour/terrace-thumb.webp';
import t6 from '../assets/images/tour/harley-thumb.webp';
import t7 from '../assets/images/tour/kitchen-thumb.webp';
import t8 from '../assets/images/tour/shop-thumb.webp';

const mobileImages = { exterior: exteriorMobile, reception: receptionMobile, ed209: ed209Mobile,
  robocop: robocopMobile, terrace: terraceMobile, harley: harleyMobile, kitchen: kitchenMobile, shop: shopMobile };

export const tourScenes = [
  { id: 'exterior', src: exterior, thumb: t0, position: 'center', mobilePosition: '43% center', x: '30%', y: '35%' },
  { id: 'reception', src: reception, thumb: t1, position: 'center', mobilePosition: '58% center', x: '73%', y: '40%' },
  { id: 'ed209', src: ed209, thumb: t2, position: 'center 44%', mobilePosition: '56% center', x: '80%', y: '35%' },
  { id: 'lounge', src: lounge, thumb: t3, position: 'center', mobilePosition: '40% center', x: '80%', y: '38%' },
  { id: 'robocop', src: robocop, thumb: t4, position: 'center 40%', mobilePosition: '54% center', x: '80%', y: '35%' },
  { id: 'terrace', src: terrace, thumb: t5, position: 'center', mobilePosition: '56% center', x: '72%', y: '35%' },
  { id: 'harley', src: harley, thumb: t6, position: 'center 60%', mobilePosition: '67% center', x: '77%', y: '35%' },
  { id: 'kitchen', src: kitchen, thumb: t7, position: 'center', mobilePosition: '51% center', x: '79%', y: '38%' },
  { id: 'shop', src: shop, thumb: t8, position: 'center', mobilePosition: '65% center', x: '75%', y: '36%' }
].map(scene => ({ ...scene, mobileSrc: mobileImages[scene.id] }));
